export const isProductType = (param: string, products: any[]) => {
  return products.map((item) => item?.seo?.url).includes(param);
};
